import React, { Component } from 'react';
import { Big3Common } from '../../../js/IncludeManager'
import { format } from "date-fns";
import { GoodsPhoto, Big3DatePicker, NoResult } from "../../../js/ComponentManager";

/* 개발담당:양유빈
 * 화면기능:주문완료/취소 화면
 * 세부설명:
*/

export class CompletedList extends Component {
    static displayName = CompletedList.name;

    constructor(props) {
        super(props);
        this.fromDate = format(Big3Common.Util.DateAdd(new Date(), -30), "yyyy-MM-dd");
        this.toDate = format(Big3Common.Util.DateAdd(new Date(), 1), "yyyy-MM-dd");      
        this.SelectMonth = 0;
        this.SelectMonthOn = false;
        this.Org_Name = "";
        this.Ord_Status = "GR";
        //다른 탭으로 돌아갔을때 다시 설정하기 위한 날자
        if (this.props.ContentState !== undefined && this.props.ContentState !== null) {
            if (this.props.ContentState.FromDate !== undefined) {
                this.fromDate = this.props.ContentState.FromDate;
            }
            if (this.props.ContentState.ToDate !== undefined) {
                this.toDate = this.props.ContentState.ToDate;
            }
            if (this.props.ContentState.SelectMonth !== undefined) {
                this.SelectMonth = this.props.ContentState.SelectMonth;
                this.SelectMonthOn = this.props.ContentState.SelectMonthOn;
                this.Org_Name = this.props.ContentState.Org_Name;
            }
            this.Ord_Status=Big3Common.Util.GetContentState(this.props.ContentState, "Ord_Status", "GR");
        }
       
        this.state = {
            Union_Uid: "",
            Ordgrp_No: "",
            FromDate: this.fromDate,
            ToDate: this.toDate,           

            OrdMgtMstList: [],
            MgtMstCount: [],
            SelectMonth: this.SelectMonth,
            SelectMonthOn: this.SelectMonthOn,
            Org_Name: this.Org_Name
        };
       
        this.handleCalendarChange = this.handleCalendarChange.bind(this);
        this.handleSearch_Click = this.handleSearch_Click.bind(this);
        this.handleDtl_Click = this.handleDtl_Click.bind(this);
        this.handleRtiDtlApp_Click = this.handleRtiDtlApp_Click.bind(this);
        this.handleTab_Click = this.handleTab_Click.bind(this);
        this.handleMonth_Click = this.handleMonth_Click.bind(this);
        this.handleOrg_Change = this.handleOrg_Change.bind(this);
        this.handleOrg_Blur = this.handleOrg_Blur.bind(this);
    }
    
    //초기화
    async componentDidMount() {
        
        await this.CallOrdMgtMstListData();
    }
    //주문목록 조회
    async CallOrdMgtMstListData() {
        try {
            Big3Common.Util.LoadingOn();
            let Data = await Big3Common.Post('api/Order/OrderMgr/GetOrdMgtMstList',
                {
                    "FromDate": this.state.FromDate,
                    "ToDate": this.state.ToDate,
                    "Ord_Status": this.Ord_Status,
                    "Org_Name": this.state.Org_Name,
                    "SelectMonthOn": this.state.SelectMonthOn===true ? "Y":"N"
                }, true);

            if (Data.codeName === Big3Common.ResultCode.Success) {
                const DataList = JSON.parse(Data.multiDataTable);
                const OrdMgtMstList = DataList.MgtMstList;
                const MgtMstCount = DataList.MgtMstCount;
                this.setState({ OrdMgtMstList: OrdMgtMstList, MgtMstCount: MgtMstCount });
            }
            else {
                console.log(Data.message);
            }
        }
        catch (e) {
            console.log("CallOrdMgtMstListData: ", e)
        }
        finally {
            Big3Common.Util.LoadingOff();
        }
        return false;
    }
    //달력일정 변경
    handleCalendarChange(retunValue) {
        let TagId = retunValue.returnId;
        this.setState({ [TagId]: retunValue.SelectDate });
        return false;
    }
    //검색버튼
    handleSearch_Click(event) {
        this.CallOrdMgtMstListData();
        event.preventDefault();
    }
    //주문 상세보기
    handleDtl_Click(event, list) {
         
        let ContentState = Big3Common.Util.Cloen(this.state);
        ContentState.Ord_Status = this.Ord_Status;
        ContentState.Union_Uid = list.union_uid;
        ContentState.Ordgrp_No = list.ordgrp_no;
        this.props.RenderComponent('OrderDtl', ContentState);
        event.preventDefault();
    }
    //소매매장 보기
    handleRtiDtlApp_Click(event, list) {

        let ContentState = Big3Common.Util.Cloen(this.state);
        ContentState.Union_Uid = list.union_uid;
        ContentState.Ordgrp_No = list.ordgrp_no;
        ContentState.Ord_Status = this.Ord_Status;
        this.props.RenderComponent('RtiDtlAp', ContentState);
        event.preventDefault();
    }
    //Tab 링크
    async handleTab_Click(event, Ord_Status) {
        if (Ord_Status === "GR" || Ord_Status === "CS") {
            if (this.Ord_Status === Ord_Status) {
                return false;
            }
            this.Ord_Status = Ord_Status;
            await this.CallOrdMgtMstListData();
        }
        else {
            let ContentState = Big3Common.Util.Cloen(this.state);
            ContentState.Ord_Status = Ord_Status;
            this.props.RenderComponent('OrderList', ContentState);
        }
        event.preventDefault();
    }
    //월별 버튼 클릭
    handleMonth_Click(event, Month) {
        let fromDate = format(Big3Common.Util.DateAdd(new Date(this.state.ToDate), -(Month * 30)), "yyyy-MM-dd");
        this.setState({ SelectMonth: Month, FromDate: fromDate });
        event.preventDefault();
    }
    //소매명 검색
    handleOrg_Change(event) {
        let textVal = event.target.value;
        this.setState({ Org_Name: textVal });
        event.preventDefault();
    }
    handleOrg_Blur(event) {
        let textVal = event.target.value;
        if (textVal === "") {
            this.CallOrdMgtMstListData();
        }
        event.preventDefault();
    }
    //탭 리스트
    Tabrender() {
        return (
            <div className="tab_box_v2">
                <div className="f_tap" onClick={(e) => { this.handleTab_Click(e, 'JM') }}><div className="s_tap">주문목록</div></div>
                <div className="f_tap" onClick={(e) => { this.handleTab_Click(e, 'PJ') }}><div className="s_tap">포장완료</div></div>
                <div className="f_tap" onClick={(e) => { this.handleTab_Click(e, 'GR') }}><div className={this.Ord_Status === "GR" ? "s_tap tap_select" : "s_tap"}>거래완료</div></div>
                <div className="f_tap" onClick={(e) => { this.handleTab_Click(e, 'CS') }}><div className={this.Ord_Status === "CS" ? "s_tap tap_select" : "s_tap"}>취소목록</div></div>
            </div>
        )
    }
    //상품리스트
    OrdMgtMstrender(DataList) {
        return (
            DataList.map(list =>
                <div className="alert_content" key={`${list.uid}${list.union_uid}${list.ordgrp_no}`}>
                    <div className="alert_img" onClick={(e) => { this.handleRtiDtlApp_Click(e, list) }}>
                        <GoodsPhoto
                            className="alert_img_in"
                            ImageSrc={list.img_220}
                        />
                    </div>
                    <div className="alert_txt" onClick={(e) => { this.handleDtl_Click(e, list) }}>
                        <div className="alert_title">{list.retail_area_nm === "" ? "" : `[${list.retail_area_nm}]`} {list.retail_org_name}</div>
                        <div className="product_name">주문 품목:  {list.goods_nms}</div>
                        <div className="product_name">주문 금액: {Big3Common.Util.Money(list.goods_price)}원</div>
                        <div className="product_name"> 결제: {list.pay_idx_nm}</div>
                        {list.ord_idx === "EX" ? <div className="excel_btn">엑셀주문장</div> : ""}
                    </div>
                </div>
            )
        )
    }    
    //날짜, 월별 검색 조건
    Searchrender() {
        if (this.state.SelectMonthOn === false) {
            return false;
        }
        return (
            <>
                <div className="select_month_box">
                    <div className={this.state.SelectMonth === 1 ? "month select pointer" : "month pointer"} onClick={(e) => { this.handleMonth_Click(e, 1) }}>1개월</div>
                    <div className={this.state.SelectMonth === 3 ? "month select pointer" : "month pointer"} onClick={(e) => { this.handleMonth_Click(e, 3) }}>3개월</div>
                    <div className={this.state.SelectMonth === 6 ? "month select pointer" : "month pointer"} onClick={(e) => { this.handleMonth_Click(e, 6) }}>6개월</div>
                </div>
                <div className="select_date_box">
                    <div className="select_date_box_input">
                        <Big3DatePicker
                            className="form-control"
                            setDate={new Date(this.state.FromDate)}
                            DateChange={this.handleCalendarChange}
                            id="FromDate"
                        />
                    </div>
                    <div className="select_date_box_input">
                        <Big3DatePicker
                            className="form-control"
                            setDate={new Date(this.state.ToDate)}
                            DateChange={this.handleCalendarChange}
                            id="ToDate"
                        />
                    </div>
                    <button type="button" className="date_s_btn" onClick={this.handleSearch_Click}>조회</button>
                </div>
            </>
        )
    }
    render() {
        const Tabrender = this.Tabrender();
        const Searchrender = this.Searchrender();
        const OrgMgt = this.state.OrdMgtMstList;
        const OrdDtList = Big3Common.Util.groupBy(OrgMgt, list => list.ord_dt);
        const OrdDtListJson = [];
        for (const item of OrdDtList.entries()) {
            OrdDtListJson.push({
                "Ord_Dt": item[0],
                "DataList": item[1],
            });
        }
        return (
            <div>
                {Tabrender }
                <div className="container_box2 m_f_margin u_padding order_box">
                    <div className="search_box sb_v2">
                        <div className="search_input_box">
                            <input type="text" placeholder="소매명을 입력해주세요."
                                className="form-control"
                                defaultValue={this.state.Org_Name}
                                onChange={this.handleOrg_Change}
                                onBlur={this.handleOrg_Blur}
                            />
                            <div className="search_btn" onClick={this.handleSearch_Click}></div>
                        </div>
                        <div className="order_select_box">
                            <div className="order_select pointer" onClick={() => { this.setState({ SelectMonthOn: this.state.SelectMonthOn === false ? true : false }) }}>기간선택</div>
                            <div className="order_select_btn"></div>
                        </div>
                        {Searchrender }
                    </div>
                    {
                        OrdDtListJson.map(list =>
                            <div key={list.Ord_Dt}>
                                <div className="date">{list.Ord_Dt}</div>
                                {this.OrdMgtMstrender(list.DataList)}
                            </div>
                        )
                    }
                </div>
                <div className="float_excel_btn" onClick={() => { this.props.RenderComponent('OrderDtlExcel') }}></div>       
                <NoResult
                    Visible={this.state.OrdMgtMstList.length === 0 ? true : false}
                    Top={"60%"}
                />
            </div>
        );
    }
}
